import graphqlClient from "../../../apollo";

class AgenciaObjetivoProvider {

    fetchCajaMensualObjetivosImport() {
        return graphqlClient.query({
            query: require('./gql/AgenciaObjetivo/fetchCajaMensualObjetivosImport.graphql'),
            fetchPolicy: "network-only"
        })
    }

    hasAgenciaObjetivoDashboardAgencia() {
        return graphqlClient.query({
            query: require('./gql/AgenciaObjetivo/hasAgenciaObjetivoDashboardAgencia.graphql'),
            fetchPolicy: "network-only"
        })
    }

    importarObjetivosAgencia(cajaMensualId, fileId) {
        return graphqlClient.mutate({
            mutation: require('./gql/AgenciaObjetivo/importarObjetivosAgencia.graphql'),
            variables: {cajaMensualId, fileId}
        })
    }

    dashboardObjetivosAgencia(agenciaId = null, cajaMensualId = null) {
        return graphqlClient.query({
            query: require('./gql/AgenciaObjetivo/dashboardObjetivosAgencia.graphql'),
            variables: {agenciaId, cajaMensualId},
            fetchPolicy: "network-only"
        })
    }

    agenciaObjetivosPorCaja(cajaMensualId, agenciaId = null) {
        return graphqlClient.query({
            query: require('./gql/AgenciaObjetivo/agenciaObjetivosPorCaja.graphql'),
            variables: {cajaMensualId, agenciaId},
            fetchPolicy: "network-only"
        })
    }
}

export default new AgenciaObjetivoProvider()
